import { render, staticRenderFns } from "./printBapp.vue?vue&type=template&id=ef22e93a&scoped=true"
import script from "./printBapp.vue?vue&type=script&lang=js"
export * from "./printBapp.vue?vue&type=script&lang=js"
import style0 from "./printBapp.vue?vue&type=style&index=0&id=ef22e93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef22e93a",
  null
  
)

export default component.exports